module.exports = __webpack_public_path__ + "img/dottorfarmaWhite.913da2fa.svg";